import { FC, useCallback, useEffect, useRef, useState } from "react";
import { Paper, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import __ from "src/utils/Translations";

interface IAbsenceTypesListSearchProps {
  isFetching: boolean;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const AbsenceTypesListSearch: FC<IAbsenceTypesListSearchProps> = ({
  isFetching,
  searchQuery,
  onSearchChange,
}) => {
  const [inputValue, setInputValue] = useState(searchQuery);

  const debouncedSearch = useRef(
    debounce((value: string) => {
      onSearchChange(value);
    }, 1000)
  ).current;

  const handleInputChange = useCallback(
    (value: string) => {
      setInputValue(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  useEffect(
    () => () => {
      debouncedSearch.cancel();
    },
    [debouncedSearch]
  );

  useEffect(() => {
    setInputValue(searchQuery);
  }, [searchQuery]);

  return (
    <Paper sx={{ padding: "1.5rem", margin: "1.5rem 0" }}>
      <TextField
        placeholder={__("Wyszukaj wniosek")}
        value={inputValue}
        type="search"
        fullWidth
        disabled={isFetching}
        onChange={(e) => handleInputChange(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
      />
    </Paper>
  );
};

export default AbsenceTypesListSearch;
